import { payments } from "@square/web-sdk";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Button from "../../components/Button";
import LoadingScreen from "../../components/LoadingScreen";
import { navigate } from "../../constants/refs";
import { setLoading, setModal } from "../../reduxSlices/ui";
import { updateUser } from "../../reduxSlices/user";
import sendRequest from "../../service";
import c from "./paymentpage.module.css";
import handleError from "../../helpers/errorHandler";

let progress = false;
const SubscriptionForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [paymentsInstance, setPaymentsInstance] = useState(null);
  const [card, setCard] = useState(null);
  const [trialStatus, setTrialStatus] = useState(false);

  const newCardPage = location.pathname === "/payment/add-card";
  const plans = {
    standard: {
      name: "Standard",
      price: "6.99",
    },
    premium: {
      name: "Premium",
      price: "9.99",
    },
  };

  useEffect(() => {
    if (!newCardPage && !plans[params.plan]) navigate(-1);
    if (!paymentsInstance) {
      initializeSquare();
    }
  }, []);

  async function initializeSquare() {
    try {
      const paymentsInstance = await payments(
        process.env.REACT_APP_SQUARE_APP_ID,
        process.env.REACT_APP_SQUARE_LOCATION_ID
      );

      const cardInstance = await paymentsInstance.card();
      await cardInstance.attach("#card-container");

      if (params.token) {
        const res = await sendRequest.get(`subscription/check-link/${params.token}/${params.plan}`);
        if (res.data.data.status) {
          setTrialStatus(true);
        } else {
          dispatch(
            setModal({
              type: "failed",
              title: "Invalid Link",
              message: "The subscription link is invalid or has expired.",
              button: {
                text: "Okay",
              },
            })
          );
        }
      }

      setPaymentsInstance(paymentsInstance);
      setCard(cardInstance);
    } catch (error) {
      handleError(error);
    }
  }

  const handleSubscription = async () => {
    if (progress) return;

    try {
      dispatch(setLoading(true));
      progress = true;
      const nonceResponse = await card.tokenize();
      if (nonceResponse.status === "OK") {
        const token = nonceResponse.token;

        if (newCardPage) {
          await sendRequest.post("user/cards/create", {
            p_token: token,
          });

          dispatch(
            setModal({
              type: "success",
              title: "Card Added",
              message: "Your new card will be used for subscription.",
              button: {
                text: "Okay",
              },
            })
          );
          navigate("/profile");
        } else {
          const requestBody = {
            p_token: token,
            plan: params.plan,
          } 
          if(trialStatus){
            requestBody.trial_token = params.token;
          }

          await sendRequest.post("subscription/subscribe", requestBody);

          dispatch(
            updateUser({
              isActive: true,
              status: "subscribed",
            })
          );
          navigate("/payment/success", { replace: true });
        }
      } else {
        handlePaymentError(nonceResponse.errors);
        console.error("Tokenization failed:", nonceResponse.errors);
      }
    } catch (error) {
      handlePaymentError(error);
    }
    dispatch(setLoading(false));
    progress = false;
  };

  function handlePaymentError(error) {
    if (
      error.response?.data?.message &&
      error.response?.data?.message[0] &&
      error.response?.data?.message[0]?.code === "INVALID_CARD_DATA"
    ) {
      dispatch(
        setModal({
          type: "failed",
          title: "Invalid Card",
          message: "Please check your card informations",
          button: {
            text: "Okay",
          },
        })
      );
    } else {
      dispatch(
        setModal({
          type: "failed",
          title: "Payment Unsuccessful",
          message: "Please try again later",
          button: {
            text: "Okay",
          },
        })
      );
    }
  }

  if (!newCardPage && !plans[params.plan]) return null;

  return (
    <div className={c.page}>
      <div className={c.left}>
        {!paymentsInstance && <LoadingScreen />}
        {/* <Link
          className={c.backButton}
          to={-1}
        >
          <img
            src={require("../../assets/images/player/back.png")}
            style={c.backIcon}
            alt="back"
          />
          Back
        </Link> */}
        <img
          className={c.logoField}
          src={require("../../assets/images/logo.png")}
          alt="blkgtv-image"
        />
        {newCardPage ? (
          <>
            <h4>Add New Card</h4>
            <div style={{ paddingRight: "10%" }}>
              Your card will be used on subscription payment for each month. You can delete your
              card or cancel your subscription any time
            </div>
          </>
        ) : (
          <>
            <h4>Subscribe to BLKGTV {plans[params.plan].name}</h4>
            {trialStatus && <h4>With 3 days free trial</h4>}
            <div className={c.priceField}>
              <h1>${plans[params.plan].price}</h1>
              <div className={c.priceLabel}>
                per<div style={{ marginTop: -12 }}>month</div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={c.right}>
        <div
          className={c.cardContainer}
          id="card-container"
        ></div>
        <Button
          text={newCardPage ? "Add Card" : "Subscribe"}
          style={c.button}
          onClick={handleSubscription}
        />
        {trialStatus && (
          <div className={c.trialText}>
            Access all content for free for 3 days. Payment will be made automatically afterwards.
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionForm;
